const LOGO = "/hstc-logo.png";

export function Logo({ size = "md", className = "" }) {
  const h = size === "lg" ? "h-11" : size === "sm" ? "h-8" : "h-9";
  return (
    <span className={`inline-flex items-center bg-white rounded-md px-1 py-0.5 ${className}`} data-testid="hstc-logo">
      <img src={LOGO} alt="Help Solve The Case™" className={`${h} w-auto object-contain`} />
    </span>
  );
}

export default Logo;
